import { inject, Pipe, PipeTransform } from '@angular/core';
import { LanguageStore } from 'src/core/stores';
import { TranslationsDto } from 'src/generated/api/nestjs-backend';

@Pipe({
  name: 'translationsDto',
  standalone: true,
  pure: false,
})
export class TranslationsDtoPipe implements PipeTransform {
  private languageStore = inject(LanguageStore);

  transform(translationsDto: TranslationsDto | null | undefined): string {
    return this.languageStore.translateDto(translationsDto)();
  }
}
